import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

function renderByVariant(variant: 'primary' | 'grey', disabled?: boolean): string {
  if (disabled) {
    return `
      pointer-events: none;
      cursor: auto;
      color: ${colors.text['disabled-300']};

      & > svg > path {
        stroke: ${colors.icon['disabled-300']};
      }
    `;
  }

  switch (variant) {
    case 'grey': return `
      color: ${colors.text['sub-500']};

      & > svg > path {
        stroke: ${colors.icon['sub-500']};
      }

      &:hover {
        color: ${colors.text['soft-400']};

        & > svg > path {
          stroke: ${colors.icon['soft-400']};
        }
      }

      &:active {
        color: ${colors.text['sub-500']};

        & > svg > path {
          stroke: ${colors.icon['sub-500']};
        }
      }
    `;
    case 'primary': return `
      color: ${colors.text['primary-base']};

      & > svg > path {
        stroke: ${colors.icon['primary-base']};
      }

      &:hover {
        color: ${colors.text['primary-dark']};

        & > svg > path {
          stroke: ${colors.icon['primary-dark']};
        }
      }

      &:active {
        color: ${colors.text['primary-base']};

        & > svg > path {
          stroke: ${colors.icon['primary-base']};
        }
      }
    `;
    default: return '';
  }
}

export const StyledLink = styled(Link) <{ variant: 'primary' | 'grey', disabled?: boolean }>`
  height: 24px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 11px;
  line-height: 150%;
  max-width: 95%;

  span {
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    min-width: 0;
  }

  ${({ disabled, variant }) => renderByVariant(variant, disabled)}
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;
